import { render, staticRenderFns } from "./GlobalIndicatorsTitle.vue?vue&type=template&id=07122f66&"
import script from "./GlobalIndicatorsTitle.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports